import { PropsWithChildren } from 'react';
import '@fluentui/react/dist/sass/Fabric.scss';
import { initializeIcons, ThemeProvider } from '@fluentui/react';
import { useSelector } from 'hooks';
import { getSelectedTheme } from 'state/slices/ui.slice';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20210407.001/assets/icons/');

const ThemeInitializer = (props: PropsWithChildren<any>): JSX.Element => {
    const theme = useSelector(getSelectedTheme);

    return (
        <ThemeProvider
            theme={theme}
            style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
        >
            {props.children}
        </ThemeProvider>
    );
};

export default ThemeInitializer;
